import React, { useCallback, useState, FormEvent } from 'react';
import { FiLock, FiAlertCircle } from 'react-icons/fi';
import * as Yup from 'yup';
import Input from '../../Input/Input';
import Button from '../../Button';
import { ForgetPasswordLink } from '../styles';
import { useAuth } from '../../../hooks/auth';
import { ErrorMessage, SignHeadText } from '../../../styles/globalStyled';

const PasswordSignIn: React.FC = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { loading, handleLogin, handleStep } = useAuth();

  const handleInputChange = useCallback((passwordText) => {
    setPassword(passwordText);
  }, []);

  const sendPassword = useCallback(
    async (event: FormEvent) => {
      event.preventDefault();
      setError('');

      if (!password) {
        setError('Senha obrigatória');
      } else {
        handleLogin({ password });
      }
    },
    [password, handleLogin],
  );

  const changeStep = useCallback((step: string) => {
    handleStep(step);
  }, []);

  return (
    <>
      <SignHeadText style={{ marginBottom: '20px' }}>
        <label>
          Insira sua senha, <br />
          por favor.
        </label>
      </SignHeadText>
      <form onSubmit={sendPassword}>
        <Input name="password" type="password" placeholder="Senha" width="full" onChangeValue={handleInputChange} />
        <ForgetPasswordLink onClick={() => changeStep('recoverPassword')}>Esqueceu a senha?</ForgetPasswordLink>
        <ErrorMessage visibility={error ? 1 : 0}>
          <FiAlertCircle size={20} />
          {error}
        </ErrorMessage>
        <div className="is-flex">
          <Button
            title="Voltar"
            type="button"
            classType="big fat outline-orange center topspace"
            onClick={() => changeStep('fillEmail')}
          />
          <Button
            title="Entrar"
            classType="big fat orange center topspace"
            style={{ marginLeft: '5px' }}
            loading={loading}
            type="submit"
          />
        </div>
      </form>
    </>
  );
};

export default PasswordSignIn;
